import { useCallback, useState } from 'react';
import type { TrainingLanguage } from '@hrms/shared';
import { readRememberedTrainingLanguage, rememberTrainingLanguage } from './lessonLanguage.js';

/**
 * The language the learner picked in the player's switcher, remembered in this browser so the next
 * course opens in it too (`null` = never picked: every lesson shows in its own language). Storage is
 * best effort — where it throws, the choice simply lasts for this page.
 *
 * `remember: false` (HR's preview) neither reads nor writes it: a preview always opens in the
 * course's own language, and looking at the Hindi version must not change HR's own courses.
 */
export function useLessonLanguage({ remember = true }: { remember?: boolean } = {}) {
  const [chosen, setChosen] = useState<TrainingLanguage | null>(() =>
    remember ? readRememberedTrainingLanguage() : null,
  );
  const choose = useCallback(
    (language: TrainingLanguage) => {
      setChosen(language);
      if (remember) rememberTrainingLanguage(language);
    },
    [remember],
  );
  return { chosen, choose };
}
